import React from "react";

const CustomTextArea = ({
   label,
   id,
   inputType,
   placeholder,
   onChange,
   errors,
   message,
   name,
   value,
   disabled,
   require,
   required,
   ...rest
}) => {
   return (
      <div className="form-group">
         {label && (
            <label className="text-capitalize" htmlFor={id}>
               {label}
               {required && <span className="text-danger">*</span>}
            </label>
         )}
         <textarea
            className="form-control"
            rows={3}
            id={id}
            name={name}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            disabled={disabled}
            {...rest}
         />
         {errors && (
            <div className="text-danger" style={{ fontSize: ".8rem" }}>
               {message}
            </div>
         )}
      </div>
   );
};

export default CustomTextArea;
